export const PageText = {
  _1: 'Aircheckr newsletter',
  _2: 'We keep you posted on our latest developments and our major blog posts.'
};

export const Categories = {
  _1: {
    title: 'Subscribe now',
    subcategories: [
      {
        key: 0,
        subtitle: 'Just once a month, not more',
        text: 'Through our newsletter, we will keep you posted on our progress and major plans. Moreover, we try to give you some more insights in air quality & its effect on our health. Don’t worry, we will not overload you with emails.',
        text_2: 'You can subscribe to our newsletter at the bottom of this page.'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/aircheckr-newsletter_page.js